import {BaseError} from './base-error';

export class UnitConversionError extends BaseError {}
